import React from "react";
import { LinkType } from "../../../../types";

type Props = {
    links: LinkType[];
};

export const Links = ({ links }: Props) => (
    <div className="pt-2">
        {links.map(({ linkRef, linkTitle, linkFollow }) => (
            <div key={linkTitle} className="px-2 py-1">
                <a
                    href={linkRef}
                    target="_blank"
                    rel={`${linkFollow ? "follow" : "nofollow"} noopener noreferrer`}
                    title={linkTitle}
                    className="underline text-blue-600 hover:text-blue-800"
                >
                    {linkTitle}
                </a>
            </div>
        ))}
    </div>
);
